import { NgModule } from '@angular/core';
import { CoreFeatureBrowserModule } from '@core/feature';

@NgModule({
  imports: [CoreFeatureBrowserModule],
})
export class CoreShellBrowserModule {}
